import { arrayParamDeserializerHelper, objectParamDeserializerHelper } from 'Angular/utils/urls';
export class ScatterPlotUrlDeserializer {
}
ScatterPlotUrlDeserializer.plotOptions = (urlValue) => objectParamDeserializerHelper(urlValue);
ScatterPlotUrlDeserializer.securities = (urlValue) => arrayParamDeserializerHelper(urlValue);
// Scatter Plot title should always be a string. Without this override, titles including ',' will be parsed
// as arrays by parseFlattenedObject
ScatterPlotUrlDeserializer.title = (urlValue) => urlValue.toString();
